import { trpc } from '@bitbot/api';
import { createGlobalStore } from 'hox';
import { useMemo, useState } from 'react';

type TabType = 'tokens' | 'deploys';

const tabs: { name: string; value: TabType }[] = [
  {
    name: 'Tokens',
    value: 'tokens',
  },
  {
    name: 'Deploys',
    value: 'deploys',
  },
];

export type NetworkType = 'all' | 'eth' | 'sol' | 'base';
export const networks: { name: string; value: NetworkType }[] = [
  {
    name: 'All networks',
    value: 'all',
  },
  {
    name: 'Ethereum',
    value: 'eth',
  },
  {
    name: 'Solana',
    value: 'sol',
  },
  {
    name: 'Base',
    value: 'base',
  },
];

export const [useMarket] = createGlobalStore(() => {
  const [activeTab, setActiveTab] = useState<TabType>('tokens');
  const [activeNetwork, setActiveNetwork] = useState<NetworkType>('all');
  // const { data } = trpc.market.getTokensList.useQuery();
  return {
    activeTab,
    setActiveTab,
    data: [],
    tabs,
    activeNetwork,
    setActiveNetwork,
    networks,
  };
});

export type Market = NonNullable<
  ReturnType<typeof useMarket>['data']
>[number];

export const useTokenDetail = function (id: string) {
  const { data } = trpc.market.getTokenDetail.useQuery(
    {
      id,
    },
    { enabled: !!id },
  );

  return { data };
};

type TTimeRange = '1d' | '7d' | '30d';
export const useTokenDetailChart = function (props: {
  tokenAddress: string;
  chain: 'ETH';
  tabs: Array<{ label: string; value: TTimeRange }>;
}) {
  const { tokenAddress, chain, tabs } = props;
  const [activeTab, setActiveTab] = useState<TTimeRange>(tabs[0].value);
  const { data } = trpc.market.getTokenChart.useQuery(
    {
      tokenAddress,
      chain,
      timeRange: activeTab,
    },
    { enabled: !!tokenAddress && !!chain },
  );
  const chartData = useMemo(() => {
    let data = [
      { price: 12, date: '2024-06-18' },
      { price: 15, date: '2024-06-19' },
    ];
    return data?.reduce(
      (prev, cur) => {
        prev.label.push(cur.date);
        prev.data.push(cur.price);
        return prev;
      },
      { label: [], data: [] } as {
        label: Array<string>;
        data: Array<number>;
      },
    );
  }, [data]);

  return {
    data: chartData,
    activeTab,
    setActiveTab,
  };
};
